import moment from 'moment';
import aes from 'aes-cross';
import crypto from 'crypto';
import { subPartner } from "../constant";

export const utils = {
 formatCurrency,
 getNumberFromCurrency,
 convertDateFormat,
 convertDateFormatDesc,
 get12HourTime,
 getCutoffTime,
 getDurationSince,
 getDateFromStartDate,
 getCharColors,
 getTransactionStatusLabel,
 getTransactionStatusColor,
 getTransactionTypeLabel,
 getMonthName,
 addSuffixToNumber,
 getMonthNumber,
 sortByDate,
 indianNumberWithCommasNew,
 calculateCompound,
 isObjectEmpty,
 hasNumber,
 hasSpecialCharacter,
 distributeBasketAmount,
 getMfuPaymentStatus,
 amazonShare,
 getSIPStartDate,
 payuRedirection,
 validatePhone,
 validatePhoneStartLetter,
 isNumber,
 convertToIntArr,
 getNonAllowedDates,
 appendZero,
 convertToCapitalize,
 deriveSecretKey,
 decryptPayload,
 encryptedPayload,
 getPKey,
 parsePayload,
 subPartnerRedirectTo
};

function formatCurrency(value) {
  if (value === '-' ) {
      return value;
  } else if(isNaN(value)) { return value}
  else {
    var formatted = new Intl.NumberFormat('en-IN',{
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(value);
    return(formatted);
  }
}

function getNumberFromCurrency(amount) {
  if(typeof amount == 'string') {
    amount = amount.replace(/[^\d\.\ ]/g, "");
  }

  return amount;
}

/**
 * Converts a date string from the format 'mm/dd/yyyy' to 'dd/mm/yyyy'
*/
function convertDateFormat(dateString) {
  var date = dateString.split(/\//);
  return [ date[1], date[0], date[2] ].join('/');
}

function convertDateFormatDesc(dateString) {
  var date = dateString.split(/\//);
  var monthName = getMonthName(date[0] - 1);

  return monthName + ' ' + date[1] + ', ' + date[2];
}

function getMonthName(month) {
  switch(parseInt(month)) {
    case 0:
      return 'Jan';
    case 1:
      return 'Feb';
    case 2:
      return 'Mar';
    case 3:
      return 'Apr';
    case 4:
      return 'May';
    case 5:
      return 'June';
    case 6:
      return 'July';
    case 7:
      return 'Aug';
    case 8:
      return 'Sept';
    case 9:
      return 'Oct';
    case 10:
      return 'Nov';
    case 11:
      return 'Dec';
    default:
      return '';
  }
}

function get12HourTime(timeString) {
  var time = timeString.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [timeString];

  if (time.length > 1) { // If time format correct
    time = time.slice (1);  // Remove full string match value

    time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }

  return '' + time[0] + time[1] + time[2] + ' ' + time[5];
}

function getDateFromStartDate(startDateString, months) {
  var date = startDateString.split(/\//);

  var startDate = new Date(date[2], date[0] - 1, date[1]);
  var endDate = moment(startDate);
  endDate.add(months, 'months');
  //new Date(new Date(startDate).setMonth(startDate.getMonth() + months));
  return endDate.format("MM/DD/YYYY")
  // return endDate.getMonth() + '/' + endDate.getDate() + '/' + endDate.getFullYear();
}

function getCutoffTime(fundType) {
  if (fundType === 'Liquid') {
    return '1.40 pm';
  }

  return '2.40 pm';
}

function getDurationSince(dateString) {
  var date = new Date(dateString);
  var today = new Date();

  var months = getMonthDiff(date, today);

  var duration = (months / 12).toFixed(0) + ' years';

  if(months % 12 !== 0) {
    var postfix = '';
    if(months % 12 === 1) {
      postfix = ' month';
    } else {
      postfix = ' months';
    }
    duration = duration + ' & ' + months % 12 + postfix;
  }
  return duration;
}

function getMonthDiff(d1, d2) {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth() + 1;
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

function getCharColors() {
    return ['rgba(0, 129, 146, 1)', 
            'rgba(0, 129, 146, 0.75)', 
            'rgba(0, 129, 146, 0.5)', 
            'rgba(0, 129, 146, 0.25)', 
            'rgba(43, 61, 87, 1)', 
            'rgba(43, 61, 87, 0.75)', 
            'rgba(43, 61, 87, 0.5)', 
            'rgba(43, 61, 87, 0.25)'];
}

function getTransactionTypeLabel(transactionType) {
  switch(transactionType) {
    case 'cart': 
    case 'Purchase': 
      return 'Purchase';
    case 'rcart': 
    case 'redeemCart': 
    case 'Redemption':
      return 'Redeem';
    case 'scart': 
    case 'switchCart': 
      return 'Switch';
    case 'sipcart': 
    case 'sipCart':
      return 'Systematic investment';
    case 'stpcart': 
    case 'stpCart':
      return 'Systematic switch';
    case 'swpcart': 
    case 'swpCart':
      return 'Systematic withdrawal';
    case 'dividend':
      return 'Dividend';
    default: return transactionType;
  }
}

function getTransactionStatusLabel(transactionStatus,cartType) {
  let badgeText =
    (cartType === "redeemCart" || cartType === "redeem")
      ?
      "ORDER PROCESSED & UNITS REDEEMED"
      :
      "ORDER PROCESSED & UNITS ALLOTED"
      
  switch(transactionStatus) {
    case 'RQ':
    case 'OA':
    case 'CL':
    case 'OR':
    case 'SA':
    case 'SR':
    case 'RA':
    case 'Send To RTA':
    case 'RTA Accepted':
      return cartType ==="redeem" ?
        "ORDER SENT FOR REDEMPTION"
        :
        'ORDER SENT FOR PROCESSING';
    case 'RTA Processed': 
    case 'RP': 
      return badgeText;
    case 'RR': 
    case 'RTA Rejected': 
    case 'Failed': 
      return 'Failed';
    
    default: 
      return transactionStatus;
  }
}

function getTransactionStatusColor(transactionStatus) {
  switch(transactionStatus) {
    case "RA":
    case 'ORDER SENT FOR PROCESSING':
      return 'warning';
      case "RP":
    case 'ORDER PROCESSED & UNITS ALLOTED':
      return 'primary';
    case 'Failed':
      return 'danger';
    default:
      return 'primary';
  }
}

function addSuffixToNumber(number) {
  number = number + '';
  var digits = number.split('');

  switch(parseInt(digits[digits.length - 1])) {
    case 1:
      return number + 'st';
    case 2:
      return number + 'nd';
    case 3:
      return number + 'rd';
    default:
      return number + 'th';
  }
}

function getMonthNumber(month) {
  switch(month) {
    case 'Jan':
    case 'jan':
    case 'january':
    case 'January':
      return 1;
    case 'feb':
    case 'february':
    case 'February':
    case 'Feb':
      return 2;
    case 'Mar':
    case 'mar':
    case 'March':
    case 'march':
      return 3;
    case 'Apr':
    case 'apr':
    case 'April':
    case 'april':
      return 4;
    case 'May':
    case 'may':
      return 5;
    case 'June':
    case 'june':
    case 'Jun':
    case 'jun':
      return 6;
    case 'July':
    case 'july':
    case 'Jul':
    case 'jul':
      return 7;
    case 'Aug':
    case 'aug':
    case 'August':
    case 'august':
      return 8;
    case 'Sept':
    case 'sept':
    case 'September':
    case 'september':
      return 9;
    case 'Oct':
    case 'oct':
    case 'October':
    case 'october':
      return 10;
    case 'Nov':
    case 'nov':
    case 'November':
    case 'november':
      return 11;
    case 'Dec':
    case 'dec':
    case 'December':
    case 'december':
      return 12;
    default:
      return 1;
  }
}

function sortByDate(dateArray) {
  return dateArray.sort((a,b) => a.x - b.x)
}

function indianNumberWithCommasNew (x) {
  if(!x) return;
  let isNegative = false
  if (x<0) 
    isNegative = true
  x=x.toString();
  var afterPoint = '';
  if(x.indexOf('.') > 0)
     afterPoint = x.substring(x.indexOf('.'),x.length);
  x = !isNegative ? Math.floor(x) : Math.ceil(x);
  x = x.toString();
  var lastThree
  var otherNumbers
  var prefix  = ''
  if(isNegative) {
    var y = x.replace('-','')
    prefix = '-'
    lastThree = y.substring(y.length-3);
    otherNumbers = y.substring(0,y.length-3);
  } else {
    lastThree = x.substring(x.length-3);
    otherNumbers = x.substring(0,x.length-3);
  }
  if(otherNumbers !== '')
      lastThree = ',' + lastThree;
  var res = prefix + otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
  return res;
}

function calculateCompound(principal, rate, tenure) {
  if (principal && rate && tenure) {
    return (principal*Math.pow((1+(rate/100)), tenure)).toFixed(0);
  }
  return 0;
}

function isObjectEmpty(obj) {
  return obj === null || obj=== undefined || (!Object.keys(obj).length > 0 && obj.constructor === Object);
}

function hasNumber (string) {
  return /\d/.test(string);
}

function hasSpecialCharacter(string) {
  return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(string);
}


function distributeBasketAmount(funds,amount) {
  if(funds && funds.length) {
    funds[1].amount += amount - (funds[0].amount + funds[1].amount)
  }
  return funds;
}

function getMfuPaymentStatus(url) {
  let types = [
    { 
      type: "logout",
      text: "We are sorry there was some error in completing your transaction, please try again.",
      modalType: "failure"
    },
    {
      type: "error",
      text: "We are sorry there was some error in completing your transaction, please try again.",
      modalType: "failure"
    },
    { 
      type: "cancel",
      text: "Your transaction has been cancelled.",
      modalType: "failure",
      title: "Transaction Cancelled"
    },
    { 
      type: "failure",
      text: "We are sorry, It looks like your transaction has failed, please try again later.",
      modalType: "failure"
    },
    { 
      type: "txnComplete",
      text: "Your Order placed Successfully.",
      modalType: "success"
    },
    {
      type: "success",
      text: "Your Order placed Successfully.",
      modalType: "success"
    }
  ];
  
  let params = new URLSearchParams(url);
  let status = params.get("type");

  let isPaymementCheck = types.some(item => (item.type === status));
  let formattedStatus = types.filter(item => (item.type === status));
  return Promise.resolve({
    success: isPaymementCheck,
    modalType: isPaymementCheck ? formattedStatus[0].modalType : "",
    text: isPaymementCheck ? formattedStatus[0].text : "",
    title: isPaymementCheck ? formattedStatus[0].title : ""
  });
}

function amazonShare() {
  if (navigator.share) {
    navigator.share({
      title: 'Amazon Save & Shop',
      text: 'Save & get 3% extra benefits!',
      url: "https://www.orowealth.com/amazon/"
    }).then(() => {
      console.log('Thanks for sharing!');
    })
    .catch(err => {
      console.log(`Couldn't share because of`, err.message);
    });
  } else {
    console.log('web share not supported');
  }
}


function getSIPStartDate(debitDates) {
  let day = moment().date();
  let min = 1000;
  let startDate = 1;
  debitDates.forEach(date => {
    if ((date - day) < min && (date - day) > 0) {
      min = date - day;
      startDate = date;
    }
  })
  return startDate;
}

function payuRedirection(url) {
  let params = new URLSearchParams(url);
  let payu = params.get("payu");
  if (payu) {
    let status = params.get("success");
    let txnId = params.get("txnId");
    
    return Promise.resolve({
      success: status === "true" ? true : false,
      txnId: txnId || ""
    });
  }
  else {
    return Promise.reject("not payu flow")
  }

}

function validatePhone(val) {
  return (/^\d{10}$/.test(val)) 
}

function validatePhoneStartLetter(val) {
  return (val.startsWith("9") || val.startsWith("8") || val.startsWith("7") || val.startsWith("6") )
}

function isNumber(val) {
  return /^\d+$/.test(val);
}

function convertToIntArr(arr) {
  console.log("arr is found",arr)
  if (!arr || !arr.length) {
    return []
  } 
  return arr.map(item => parseInt(item))
}

function appendZero(day) {
  let length = day ? day.toString().split("").length : 0;
  return length > 1 ? day : "0" + day.toString() 
}

function getNonAllowedDates() {
  let today = moment();
  var currDate = today.format("D")
  currDate = parseInt(currDate)
  return [currDate-1, currDate, currDate+1]
}

function deriveSecretKey() {
  const buffer = Buffer.from([0xbe, 0xff, 0xa6, 0x55, 0x16, 0x39, 0x8e, 0x92, 0x1f, 0xce, 0x58, 0x12, 0xdb, 0x92, 0x6e, 0x2f]);
  const iterations = 100000;   
  const keyLength = 16;        
  const digest = 'sha256';     

  // Derive the key using PBKDF2
  const derivedKey = crypto.pbkdf2Sync('userPassword', buffer, iterations, keyLength, digest);
  // return '12345678123456781234567812345678';
  return derivedKey.toString('hex').slice(0, 16);
}

function getPKey() {
  if (String(process.env.REACT_APP_IS_PKEY) === "true") {
    return sessionStorage.getItem("pkey");
  }
}

function parsePayload(payload, contentType) {
  if (String(process.env.REACT_APP_IS_PKEY) === "true" && utils.getPKey() && payload?.payload) {
    /* if (contentType && contentType === "<value>") {
      return // parse different content-type.
    } */
    return JSON.parse(utils.decryptPayload(payload));
  } else {
    return payload;
  }
}

function encryptedPayload(payload) {
  if (String(process.env.REACT_APP_IS_PKEY) === "true" && utils.getPKey()) {
    const encrypted = aes.enc(JSON.stringify(payload), deriveSecretKey());
    return encrypted;
  }
  return payload;
}

function decryptPayload(payload) {
  if (String(process.env.REACT_APP_IS_PKEY) === "true" && utils.getPKey()) {
    const decrypted = aes.dec(payload?.payload, deriveSecretKey());
    return decrypted;
  } else {
    return payload;
  }
}

function convertToCapitalize(str) {
  if (str.length) {
    return str.split(' ').map(item => 
      item.charAt(0).toUpperCase() + item.toLowerCase().substring(1, item.length)
    ).join(' ');
  }
}

function subPartnerRedirectTo(id) {
  let redirectUrl = subPartner.default.redirectUrl;

  if (id) {
    Object.keys(subPartner).forEach(item => {
      if (item === id) {
        redirectUrl = subPartner[id].redirectUrl;
        return;
      }
    });
  }

  return redirectUrl;
}